<template>
  <v-alert tile type="error"> The page you're looking for does not exist.</v-alert>
</template>

<script>
export default {
  name: 'http404',
}
</script>
